import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminPanel\UsersController::index
* @see app/Http/Controllers/AdminPanel/UsersController.php:21
* @route '/admin-panel/users'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin-panel/users',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\UsersController::index
* @see app/Http/Controllers/AdminPanel/UsersController.php:21
* @route '/admin-panel/users'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\UsersController::index
* @see app/Http/Controllers/AdminPanel/UsersController.php:21
* @route '/admin-panel/users'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\UsersController::index
* @see app/Http/Controllers/AdminPanel/UsersController.php:21
* @route '/admin-panel/users'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\UsersController::index
* @see app/Http/Controllers/AdminPanel/UsersController.php:21
* @route '/admin-panel/users'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\UsersController::index
* @see app/Http/Controllers/AdminPanel/UsersController.php:21
* @route '/admin-panel/users'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\UsersController::index
* @see app/Http/Controllers/AdminPanel/UsersController.php:21
* @route '/admin-panel/users'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

const users = {
    index: Object.assign(index, index),
}

export default users